
import React from 'react';
import { Check } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { cn } from "@/lib/utils";

interface TicketFeatureProps {
  feature: React.ReactNode;
  ticketKey: string;
  featureIndex: number;
  isLast?: boolean;
  ticketId?: number;
}

const TicketFeature = ({ feature, ticketKey, featureIndex, isLast = false, ticketId = 1 }: TicketFeatureProps) => {
  // Get check icon color based on ticket ID
  const getCheckColor = (id: number) => {
    switch (id) {
      case 1:
        return "text-blue-600";
      case 2:
        return "text-green-600";
      case 3:
        return "text-blue-600";
      default:
        return "text-blue-600";
    }
  };
  
  // Get separator color based on ticket ID
  const getSeparatorColor = (id: number) => {
    switch (id) {
      case 1:
        return "bg-blue-200";
      case 2:
        return "bg-red-200";
      case 3:
        return "bg-blue-200";
      default:
        return "bg-gray-200";
    }
  };

  // Format feature text based on line position
  const formatFeatureText = (feature: React.ReactNode, index: number) => {
    // Third line (index 2) should be bold and red
    if (index === 2) {
      return (
        <span className="text-red-600 font-bold text-sm">
          {feature}
        </span>
      );
    }
    // All other lines should be black and unbold with smaller text
    return <span className="text-black text-sm">{feature}</span>;
  };

  return (
    <>
      <li key={`${ticketKey}-feature-${featureIndex}`} className="flex items-start py-2 group">
        <Check className={cn("h-5 w-5 mr-2 shrink-0 mt-0.5 transition-transform group-hover:scale-110", getCheckColor(ticketId))} />
        {formatFeatureText(feature, featureIndex)}
      </li>
      {!isLast && (
        <Separator className={cn("my-1", getSeparatorColor(ticketId))} />
      )}
    </>
  );
};

export default TicketFeature;
